import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import { sdkTypes } from '@vansite/ts-sharetribe-flex-sdk';
import Decimal from 'decimal.js';
import React from 'react';
import { useIntl } from 'react-intl';

import config from '../../../config';
import { formatMoney } from '../../../util/currency';
import { FormattedMessage } from '../../../util/reactIntl';
import {
  COMMISSION_LINE_ITEMS,
  LINE_ITEM_LISTING_CONTINGENT,
  LINE_ITEM_NIGHT,
  NEGATIVE_LINE_ITEMS,
} from '../../../util/types';
import { itemValueStyles, subTotalLineItemStyles, totalDividerStyles } from './BookingBreakdown.styles';

const { Money } = sdkTypes;

/**
 * Calculates the total price in sub units for multiple line items.
 */
const lineItemsTotal = (lineItems) => {
  const amount = lineItems.reduce((total, item) => {
    return total + item.lineTotal.amount;
  }, 0);
  const currency = lineItems[0] ? lineItems[0].lineTotal.currency : config.currency;
  return new Money(new Decimal(amount).round().toNumber(), currency);
};

/**
 * @param {Object} props
 * @param {Array} props.lineItems line items to sum up, see adjustLineItemsForDisplay
 * @param {'customer'|'provider'} props.userRole role the breakdown is rendered for
 */
const LineItemRefundSubTotalMaybe = ({ lineItems, userRole }) => {
  const intl = useIntl();

  let items = JSON.parse(JSON.stringify(lineItems));

  const nightItem = items.find(
    (item) => item.code === LINE_ITEM_NIGHT && item.lineTotal.amount < 0,
  );

  if (!nightItem) return null;

  items = items.filter((item) => item.includeFor.includes(userRole));

  // Remove commission line items
  items = items.filter((item) => !COMMISSION_LINE_ITEMS.includes(item.code));

  // Remove vouchers as they are negative
  items = items.filter((item) => !NEGATIVE_LINE_ITEMS.includes(item.code));

  // Remove listing contingent line items
  items = items.filter((item) => item.code !== LINE_ITEM_LISTING_CONTINGENT);

  if (items.length === 0) return null;

  // line totals of those line items combined
  const subTotal = lineItemsTotal(items);

  const formattedSubTotal = formatMoney(intl, subTotal);

  return (
    <>
      <Divider sx={totalDividerStyles} />
      <Box sx={subTotalLineItemStyles}>
        <Typography fontWeight="bold" sx={{ flex: 1 }} variant="lineItemLabel">
          <FormattedMessage id="BookingBreakdown.subTotal" />
        </Typography>
        <Typography fontWeight="bold" sx={itemValueStyles} variant="lineItemLabel">{formattedSubTotal}</Typography>
      </Box>
    </>
  );
};

export default LineItemRefundSubTotalMaybe;
